<template>
<div>
  <div class="p-1">
    <span></span>
    <ul class="list-group list-group-flush list">
      <tree-item
          v-for="(rootNode, index) in treeData"
          :key="index"
          :item="rootNode"
          @select-item="selectItem"
          @add-item="addItem"
      ></tree-item>
    </ul>
  </div>
</div>
</template>

<script>
// import { mapGetters } from 'vuex';
import TreeItem from '#/ui/Components/TreeItem.vue';

export default {
  props: {
    // rootEntities: {
    //   type: Array,
    //   default() {
    //     return [];
    //   },
    // },
    // selectedItem: {
    //   type: Object,
    //   default() {
    //     return null;
    //   },
    // },
  },
  mounted() {
    console.log('loading tree in treeView...', this.jobId);
    this.treeData = this.$store.getters['jobs/roots'](this.jobId);
    console.log('loaded tree in treeView:', this.treeData);
  },
  components: {
    TreeItem,
  },
  data() {
    return {
      treeData: null,
    };
  },
  computed: {
    jobId() {
      return this.$route.params.jobId;
    },
  },
  methods: {
    selectItem(item) {
      this.$emit('select-item', item);
      // Vue.set(item, 'children', []);
      // this.addItem(item);
    },
    addItem(item) {
      item.children.push({
        name: 'new stuff',
      });
    },
  },
};
</script>

<style scoped>
body {
  font-family: Menlo, Consolas, monospace;
  color: #444;
}
.item {
  cursor: pointer;
}
.bold {
  font-weight: bold;
}
</style>
